





























import {Component, Vue, Model, Prop} from "vue-property-decorator";
import request from "@/util/request";
import _ from 'lodash';


@Component
export default class printHtml extends Vue {
    @Model("change", {type: Object})
    readonly value !: {
        name: string,
        id: number,
    };


    defaultPageWidth = 800;
    @Prop()
    parentId!: string;
    @Prop()
    name!: string;

    pdf = {
        id: null,
        name: null,
    }

    showCanvas = false;

    created() {

    }

    get pdfId() {
        return this.parentId;
    }

    get pdfName() {
        return this.name;
    }


    get excelName() {
        return this.name;
    }

    startCreateExcel() {

        if (this.pdfId) {

            this.HtmlExportToPdf(this.pdfId, this.pdfName);
        }
    }


    getBase64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    }


  netGetCanvasBuffer(tableId, name) {

        var cntElem = $('#' + tableId)[0];
        var shareContent = cntElem;//需要截图的包裹的（原生的）DOM 对象
        var width = shareContent.offsetWidth; //获取dom 宽度
        var height = shareContent.offsetHeight; //获取dom 高度
        var canvas = document.createElement("canvas"); //创建一个canvas节点
        var scale = 2; //定义任意放大倍数 支持小数
        canvas.width = width * scale; //定义canvas 宽度 * 缩放
        canvas.height = height * scale; //定义canvas高度 *缩放
        let content = canvas.getContext("2d");
        // @ts-ignore
        content.scale(scale, scale); //获取context,设置scale
        var rect = cntElem.getBoundingClientRect();//获取元素相对于视察的偏移量
        // // @ts-ignore
        // content.translate(-rect.left, -rect.top);//设置context位置，值为相对于视窗的偏移量负值，让图片复位

        var opts = {
            scale: 1, // 添加的scale 参数
            canvas: canvas, //自定义 canvas
            // logging: true, //日志开关，便于查看html2canvas的内部执行流程
            width: width, //dom 原始宽度
            height: height,
            useCORS: true,// 【重要】开启跨域配置
            background: "#fff"
        };

        var that = this;
        // @ts-ignore
        html2canvas(cntElem, opts).then(function (canvas) {
            // that.showCanvas = true;
            // setTimeout(function () {
            //     window.document.getElementById('targetCanvas').appendChild(canvas);
            // }, 100)
            var context = canvas.getContext('2d');
            // 【重要】关闭抗锯齿
            context.mozImageSmoothingEnabled = false;
            context.webkitImageSmoothingEnabled = false;
            context.msImageSmoothingEnabled = false;
            context.imageSmoothingEnabled = false;

            // var contentWidth = canvas.width;
            // var contentHeight = canvas.height;

            var pageData = canvas.toDataURL('image/jpeg', 1.0);



          const targetWidth=that.defaultPageWidth;
            //可以设置宽度的
          var image = new Image(targetWidth);
          // @ts-ignore
          image.src =pageData;
          that.printContent(image);


          console.log("想要canvas..");


        })
    }

    HtmlExportToPdf(tableId?: string, name?: string) {
        // this.getPdfBuffer(tableId,this.tableLabel.name);
        this.netGetCanvasBuffer(tableId, name);
    }

  printContent(content) {

    //@ts-ignore
    this.$(content).print({
      globalStyles: true,//是否包含父文档的样式，默认为true
      mediaPrint: false,//是否包含media='print'的链接标签。会被globalStyles选项覆盖，默认为false
      stylesheet: null,//外部样式表的URL地址，默认为null
      noPrintSelector: ".no-print",//不想打印的元素的jQuery选择器，默认为".no-print"
      iframe: true,//是否使用一个iframe来替代打印表单的弹出窗口，true为在本页面进行打印，false就是说新开一个页面打印，默认为true
      append: null,//将内容添加到打印内容的后面
      prepend: null,//将内容添加到打印内容的前面，可以用来作为要打印内容
      // deferred: $.Deferred()//回调函数
    })
  }

}
